/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  en: {
    "menu.reports": "Reports",
    "menu.help": "Help",
    "title.reports": "Reports",
    language: "Language",
    "text.logout": "Logout",
    "text.noReport": "Report not configured",
  },
  fi: {
    "menu.reports": "Raportit",
    "menu.help": "Auta",
    "title.reports": "Raportit",
    language: "Kieli",
    "text.logout": "Logout",
    "text.noReport": "Report not configured",
  },
  sv: {
    "menu.reports": "Rapporter",
    "menu.help": "Hjälp",
    "title.reports": "Rapporter",
    language: "Språk",
    "text.logout": "Logout",
    "text.noReport": "Report not configured",
  },
};
